module.exports = __webpack_public_path__ + "static/00005.49d455d5.jpg";